// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21MXA","rootMobile":"styles_rootMobile__399k4"};